var $388b617130f03bd4$exports = {};
const $388b617130f03bd4$var$heroImg = document.querySelector(".full-hero__img");
const $388b617130f03bd4$var$backdropSections = document.querySelectorAll(".backdrop-section");
for(let i = 0; i < $388b617130f03bd4$var$backdropSections.length; i++){
    const backdropSection = $388b617130f03bd4$var$backdropSections[i];
    const backgroundImg = backdropSection.querySelector(".backdrop-section__bg");
    const top = backdropSection.getBoundingClientRect().y;
    backgroundImg.style.top = `${(window.scrollY - (top + window.scrollY)) / 2}px`;
}
document.addEventListener("scroll", ()=>{
    for(let i = 0; i < $388b617130f03bd4$var$backdropSections.length; i++){
        const backdropSection = $388b617130f03bd4$var$backdropSections[i];
        const backgroundImg = backdropSection.querySelector(".backdrop-section__bg");
        const top = backdropSection.getBoundingClientRect().y;
        backgroundImg.style.top = `${(window.scrollY - (top + window.scrollY)) / 2}px`;
    }
    if ($388b617130f03bd4$var$heroImg) $388b617130f03bd4$var$heroImg.style.top = `${window.scrollY / 2}px`;
});


//# sourceMappingURL=index.38af11ed.js.map
